import React, { useState } from 'react';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { useRecordingControl } from 'features/toolbar/toolbar/controls/recording/useRecordingControl';
import { RecordingIcon } from 'features/toolbar/toolbar/controls/recording/RecordingIcon';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import RecordingOptionsDialog from 'features/toolbar/toolbar/controls/recording/RecordingOptionsDialog';

const RecordingControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const {
    toggleRecording,
    recorderStatus,
    active,
    icon,
    label,
    isFeatureAvailable,
    bookmarksAvailable,
  } = useRecordingControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const recordingStarted = recorderStatus === 'started';

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (recordingStarted && bookmarksAvailable) {
      setDialogOpen(true);
    } else {
      onClick?.(event);
      toggleRecording();
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <MobileMenuItem
        id="recording-control"
        icon={<RecordingIcon name={icon} active={active} />}
        selected={active}
        disabled={recorderStatus === 'starting'}
        onClick={handleClick}
      >
        {label}
      </MobileMenuItem>
      {bookmarksAvailable && <RecordingOptionsDialog open={dialogOpen} onClose={handleClose} />}
    </>
  );
};

export default RecordingControlMobile;
